import { useCallback } from 'react';
import { DEFAULT_TIME_BASED_ANIMATION_DURATION } from '../constants';
import type { SavedConfig } from '../types';

export const useSpringRelatedAnimationConfig = (
  savedConfig: SavedConfig,
  updateSavedConfig: (newValue: SavedConfig) => void,
  defaultAnimationDuration: number | undefined,
) => {
  const { animationDuration, springFriction, springTension } = savedConfig;

  const onChangeIsSpringBased = useCallback(
    (b: boolean) =>
      updateSavedConfig({
        ...savedConfig,
        animationDuration: b
          ? undefined
          : animationDuration ?? defaultAnimationDuration ?? DEFAULT_TIME_BASED_ANIMATION_DURATION,
      }),
    [animationDuration, defaultAnimationDuration, savedConfig, updateSavedConfig],
  );

  const onChangeAnimationDuration = useCallback(
    (v: number) => updateSavedConfig({ ...savedConfig, animationDuration: v }),
    [savedConfig, updateSavedConfig],
  );

  const onChangeSpringFriction = useCallback(
    (v: number) => updateSavedConfig({ ...savedConfig, springFriction: v }),
    [savedConfig, updateSavedConfig],
  );

  const onChangeSpringTension = useCallback(
    (v: number) => updateSavedConfig({ ...savedConfig, springTension: v }),
    [savedConfig, updateSavedConfig],
  );

  return {
    animationDuration,
    springFriction,
    springTension,
    onChangeIsSpringBased,
    onChangeAnimationDuration,
    onChangeSpringFriction,
    onChangeSpringTension,
  };
};
